import InlineToast from "tds/inlineToast";

export { InlineToast };

customElements.define("tds-inline-toast", InlineToast.CustomElementConstructor);
